import { Component, OnInit, Input } from '@angular/core';

/**
 * Component per mostrar el marcador d'un radar
 */ 
@Component({
  selector: 'app-radar',
  templateUrl: './radar.component.html',
  styleUrls: ['./radar.component.css']
})
export class RadarComponent implements OnInit {

  /**
   * Feature que conté les propietats per crear el marcador
   */
  @Input() feature;

  /**
   * Capa a la qual pertany el marcador
   */
  @Input() layer;

  /**
   * Conté les propietats del feature
   */
  properties;

  /**
   * Url de la icona a mostrar
   */
  iconUrl: string;

  /**
   * Descripció del tipus de radar que es tracta
   */
  description: string; 

  /**
   * URL de API google maps per obtenir imatge de localització del radar
   */
  imageUrl: string;

  /**
   * Tipus de radar 
   */
  type: string;

  /**
   * Velocitat màxima del radar
   */
  speed: string;

  /**
   * Direcció en la qual esà colocat el radar
   */
  direction: string;

  /**
   * Latitud de les coordenades del radar
   */
  latitude: string; 

  /**
   * Longitud de les coordenades del radar
   */
  longitude: string;

  /**
   * @ignore
   */
  constructor() { }

  /**
   * Inicialitza les propietats del component
   */
  ngOnInit() {


    this.properties = this.feature.properties;
    this.iconUrl = 'assets/img/' + this.layer + '_MARKER.svg';
    this.description = this.properties.description;
    this.latitude = this.feature.geometry.coordinates[1];
    this.longitude = this.feature.geometry.coordinates[0];
    this.imageUrl = "https://maps.googleapis.com/maps/api/staticmap?center=" +
                    this.latitude + "," + this.longitude +
                    "&zoom=" + "16" +
                    "&size=" + "225x135" +
                    "&format=" + "png" +
                    "&scale=" + "1" + 
                    "&maptype=" + "hybrid" + 
                    "&markers=" + "color:red|" + this.latitude + "," + this.longitude +
                    "&key=" + "AIzaSyCA1dCbPTgK0I-8FCWpAk2Qs4U6TGcZbG0";
    
    this.type = this.properties.description;
    this.speed = this.properties.speed;
    this.direction = this.properties.direction;

  }

}
